import { FC } from 'react';
import classNames from 'classnames';
import styles from './bt-stepper.module.scss';

/** complete: the consumer says the step is filled in. */
export type BtStepperStep = { key: string; label: string; complete: boolean };

type Props = {
  steps: BtStepperStep[];
  current: number;
  maxReached: number;
  onStepClick: (index: number) => void;
  /** Screen text for the ✓. */
  doneLabel?: string;
};

export type BtStepperProps = Props;

const BtStepper: FC<Props> = ({ steps, current, maxReached, onStepClick, doneLabel = '' }) => (
  <ol className={styles.stepper}>
    {steps.map((step, index) => {
      const isCurrent = index === current;
      const reached = index <= maxReached;
      const clickable = reached && !isCurrent;
      const ticked = clickable && step.complete;
      return (
        <li key={step.key}>
          <button
            type="button"
            className={classNames(styles.step, {
              [styles.current]: isCurrent,
              [styles.done]: ticked,
              [styles.reached]: clickable && !ticked,
            })}
            disabled={!clickable}
            aria-current={isCurrent ? 'step' : undefined}
            onClick={() => onStepClick(index)}
          >
            <span className={styles.circle}>
              {ticked ? (
                <>
                  <span aria-hidden="true">✓</span>
                  {doneLabel && <span className={styles.screenText}>{doneLabel}</span>}
                </>
              ) : (
                index + 1
              )}
            </span>
            <span className={styles.label}>{step.label}</span>
          </button>
        </li>
      );
    })}
  </ol>
);

export default BtStepper;
